<p>stream-objectives works!</p>
